// ============================================================================
// ENGLISH TRANSLATIONS - CHAPTER 5: THE EARLY CHURCH
// ============================================================================
// Levels 53-65 (13 levels, 39 questions)

export const chapter5Translations = {
  name: "The Early Church",
  description: "And you will receive power...",
  
  spiritualWisdom: {
    principle: "The Holy Spirit gives power and courage to witness",
    scripture: "You will receive power when the Holy Spirit comes on you; and you will be my witnesses (Acts 1:8)",
    application: "The Church is born in the fire of the Spirit and grows through courageous witness"
  },
  
  levels: {
    53: {
      name: "The Ascension",
      challenge: "You will be my witnesses... to the ends of the earth...",
      easy: {
        question: "How many days after his resurrection did Jesus ascend to heaven?",
        options: ["30 days", "40 days", "50 days", "60 days"],
        hint: "The biblical number of preparation",
        funFact: "☁️ 40 days of intensive teaching before the worldwide mission!"
      },
      medium: {
        question: "What promise does Jesus make before ascending to heaven?",
        options: [
          "He will return soon",
          "He will send the Holy Spirit with power",
          "He will build a church",
          "He will punish the wicked"
        ],
        hint: "A power from on high",
        funFact: "⚡ Promise of the Holy Spirit - transformation of fearful disciples!"
      },
      hard: {
        question: "What does the Ascension symbolize in our spiritual life?",
        options: [
          "The end of Jesus' presence",
          "Jesus reigns and intercedes for us in heaven",
          "A definitive separation",
          "A symbolic myth"
        ],
        hint: "It's about his glorified and active presence",
        funFact: "👑 Jesus reigns at God's right hand and intercedes for us!"
      }
    },
    
    54: {
      name: "Pentecost",
      challenge: "They were all filled with the Holy Spirit and began to speak...",
      easy: {
        question: "How many days after the Ascension did Pentecost occur?",
        options: ["7 days", "10 days", "14 days", "20 days"],
        hint: "About ten days",
        funFact: "🔟 10 days of intense prayer prepare for the Spirit's outpouring!"
      },
      medium: {
        question: "In what form did the Holy Spirit appear?",
        options: [
          "Like a violent wind",
          "Like tongues of fire",
          "Like a dove",
          "Like a light"
        ],
        hint: "Flames that rest on each disciple",
        funFact: "🔥 Tongues of fire: the Spirit gives courage and gift of languages!"
      },
      hard: {
        question: "What does Pentecost represent for the universal Church?",
        options: [
          "An isolated historical event",
          "The official birth of the missionary Church",
          "A miracle of curiosity",
          "The beginning of celebrations"
        ],
        hint: "It's about the Church's birth certificate",
        funFact: "🎂 Pentecost = Church's birthday, beginning of worldwide mission!"
      }
    },

    55: {
      name: "Peter's First Sermon",
      challenge: "What shall we do, brothers? Repent...",
      easy: {
        question: "How many people were baptized after Peter's sermon?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Three thousand souls",
        funFact: "🌊 3000 baptisms in one day - extraordinary spiritual revival!"
      },
      medium: {
        question: "What did Peter accuse the crowd of?",
        options: [
          "Ignorance",
          "Crucifying Jesus, the Messiah",
          "Lack of faith",
          "Hypocrisy"
        ],
        hint: "The supreme crime against the Son of God",
        funFact: "⚔️ Peter, who had denied Jesus, now proclaims his divinity!"
      },
      hard: {
        question: "How does Peter's transformation encourage us?",
        options: [
          "Some people can't change",
          "The Holy Spirit can transform anyone into a bold witness",
          "Only apostles can preach",
          "Education is most important"
        ],
        hint: "It's about the Spirit's transforming power",
        funFact: "🦁 From denier to bold preacher - Holy Spirit transformation!"
      }
    },

    56: {
      name: "The Early Christian Community",
      challenge: "They devoted themselves to the apostles' teaching and fellowship...",
      easy: {
        question: "To what four things did the early Christians devote themselves?",
        options: [
          "Prayer, fasting, worship, evangelism",
          "Teaching, fellowship, breaking bread, prayer",
          "Study, work, rest, celebration",
          "Singing, dancing, feasting, traveling"
        ],
        hint: "The four pillars of early church life",
        funFact: "🏛️ Four foundations that built the strongest community in history!"
      },
      medium: {
        question: "How did the early Christians share their possessions?",
        options: [
          "They kept everything private",
          "They sold property and shared everything in common",
          "Only the apostles owned things",
          "They gave 10% to the church"
        ],
        hint: "Radical sharing based on love",
        funFact: "❤️ Love made them family - no one had need among them!"
      },
      hard: {
        question: "What made the early church so attractive to outsiders?",
        options: [
          "Their wealth",
          "Their unity, love, and joyful sharing",
          "Their buildings",
          "Their political power"
        ],
        hint: "It's about the quality of their relationships",
        funFact: "✨ 'See how they love one another!' - their witness through unity!"
      }
    },

    57: {
      name: "The Healing at the Beautiful Gate",
      challenge: "Silver and gold I do not have, but what I have I give you...",
      easy: {
        question: "What did the lame man ask for at the temple gate?",
        options: ["Healing", "Money", "Food", "Prayer"],
        hint: "What beggars typically request",
        funFact: "💰 He asked for coins but received complete healing - God's abundance!"
      },
      medium: {
        question: "In whose name did Peter heal the lame man?",
        options: [
          "In his own name",
          "In the name of Jesus Christ of Nazareth",
          "In God's name",
          "In the apostles' name"
        ],
        hint: "The name above all names",
        funFact: "✝️ Jesus' name has power even when he's physically absent!"
      },
      hard: {
        question: "What does this miracle teach about spiritual priorities?",
        options: [
          "Money solves all problems",
          "Spiritual healing is greater than material gifts",
          "Only apostles can heal",
          "Miracles don't happen today"
        ],
        hint: "It's about what truly matters in life",
        funFact: "🏃 The man went walking, leaping, and praising God - complete restoration!"
      }
    },

    58: {
      name: "Persecution Begins",
      challenge: "We must obey God rather than men...",
      easy: {
        question: "Who first arrested Peter and John?",
        options: [
          "Roman soldiers",
          "Temple priests and Sadducees",
          "Pharisees",
          "King Herod"
        ],
        hint: "Religious authorities opposed to resurrection teaching",
        funFact: "🏛️ Sadducees denied resurrection - Jesus' rising threatened their doctrine!"
      },
      medium: {
        question: "What was the apostles' response to threats?",
        options: [
          "They stopped preaching",
          "They hid in fear",
          "We must obey God rather than men",
          "They asked for protection"
        ],
        hint: "A declaration of higher authority",
        funFact: "⚖️ Civil disobedience when human law conflicts with God's command!"
      },
      hard: {
        question: "How should Christians respond to persecution today?",
        options: [
          "Fight back violently",
          "Remain faithful while showing love to persecutors",
          "Compromise their beliefs",
          "Seek revenge"
        ],
        hint: "It's about faithful love even under pressure",
        funFact: "❤️ Persecution often spreads the Gospel faster - blood of martyrs!"
      }
    },

    59: {
      name: "Ananias and Sapphira",
      challenge: "You have not lied to men but to God...",
      easy: {
        question: "What did Ananias and Sapphira lie about?",
        options: [
          "Their age",
          "The price of their land",
          "Their marriage",
          "Their background"
        ],
        hint: "They kept back part of the proceeds",
        funFact: "💰 They wanted credit for full generosity while keeping money back!"
      },
      medium: {
        question: "What happened to them as a result of their lie?",
        options: [
          "They were forgiven",
          "They died immediately",
          "They were expelled",
          "They lost their property"
        ],
        hint: "Divine judgment was swift and severe",
        funFact: "⚡ God's holiness demands truth - lying to the Spirit brings death!"
      },
      hard: {
        question: "What does this incident teach about God's holiness?",
        options: [
          "God is cruel",
          "Holiness requires absolute honesty, especially in sacred matters",
          "Only big sins matter",
          "We can deceive God"
        ],
        hint: "It's about the sacred nature of truth in God's presence",
        funFact: "🔥 Early church purity maintained by God's protective judgment!"
      }
    },

    60: {
      name: "The Seven Deacons",
      challenge: "Choose seven men full of the Spirit and wisdom...",
      easy: {
        question: "Why were deacons chosen?",
        options: [
          "To preach sermons",
          "To serve tables and distribute food",
          "To collect money",
          "To guard the temple"
        ],
        hint: "Practical service to free apostles for prayer and preaching",
        funFact: "🍽️ Serving tables with the same Spirit-filled dignity as preaching!"
      },
      medium: {
        question: "What qualities were required for deacons?",
        options: [
          "Wealth and education",
          "Full of the Spirit and wisdom",
          "Good speakers",
          "Young and strong"
        ],
        hint: "Spiritual qualifications, not worldly ones",
        funFact: "✨ Even practical service requires spiritual maturity!"
      },
      hard: {
        question: "What does this teach about church organization?",
        options: [
          "Hierarchy is everything",
          "Spiritual gifts should match practical needs",
          "Only apostles matter",
          "Organization isn't important"
        ],
        hint: "It's about Spirit-led structure for effective ministry",
        funFact: "🏗️ Good organization multiplies ministry effectiveness!"
      }
    },

    61: {
      name: "Stephen's Witness",
      challenge: "His face was like the face of an angel...",
      easy: {
        question: "What was Stephen known for?",
        options: [
          "Being wealthy",
          "Being full of faith and the Holy Spirit",
          "Being educated",
          "Being young"
        ],
        hint: "His spiritual qualities, not worldly attributes",
        funFact: "👼 Stephen's face shone like an angel - God's presence visible!"
      },
      medium: {
        question: "What did Stephen's opponents accuse him of?",
        options: [
          "Stealing money",
          "Speaking against the temple and the law",
          "Political rebellion",
          "Immorality"
        ],
        hint: "Religious charges about sacred institutions",
        funFact: "🏛️ Truth about Jesus threatens religious establishments!"
      },
      hard: {
        question: "How did Stephen respond to false accusations?",
        options: [
          "He defended himself angrily",
          "He preached the Gospel with courage and love",
          "He tried to escape",
          "He remained silent"
        ],
        hint: "He used the opportunity to witness",
        funFact: "⚔️ Stephen turned his trial into a Gospel presentation!"
      }
    },

    62: {
      name: "Stephen's Martyrdom",
      challenge: "Lord, do not hold this sin against them...",
      easy: {
        question: "How did Stephen die?",
        options: [
          "By crucifixion",
          "By stoning",
          "By sword",
          "By poison"
        ],
        hint: "The Jewish method of execution for blasphemy",
        funFact: "🪨 First Christian martyr died by stoning - like Jesus, falsely accused!"
      },
      medium: {
        question: "What did Stephen see before he died?",
        options: [
          "Angels",
          "Jesus standing at God's right hand",
          "His family",
          "A bright light"
        ],
        hint: "A vision of heaven opened",
        funFact: "👁️ Heaven opened for the first martyr - Jesus standing to welcome him!"
      },
      hard: {
        question: "What were Stephen's last words?",
        options: [
          "Revenge my death",
          "Lord, do not hold this sin against them",
          "I forgive you",
          "Remember me"
        ],
        hint: "Words of forgiveness like Jesus on the cross",
        funFact: "💝 Like Jesus, Stephen died forgiving his murderers - perfect discipleship!"
      }
    },

    63: {
      name: "The Great Persecution",
      challenge: "All were scattered except the apostles...",
      easy: {
        question: "Who led the persecution against Christians?",
        options: [
          "Pontius Pilate",
          "Saul of Tarsus",
          "King Herod",
          "The Romans"
        ],
        hint: "A zealous Pharisee who later became Paul",
        funFact: "🔥 Saul's persecution unknowingly served God's plan to spread the Gospel!"
      },
      medium: {
        question: "What was the result of the persecution?",
        options: [
          "Christianity died out",
          "Christians scattered and preached everywhere",
          "Everyone hid in fear",
          "The apostles left Jerusalem"
        ],
        hint: "Scattering led to spreading the Gospel",
        funFact: "🌱 Persecution scattered the seeds - Gospel planted in many places!"
      },
      hard: {
        question: "How does God use persecution for His purposes?",
        options: [
          "He doesn't - it's just evil",
          "Persecution often spreads the Gospel and strengthens faith",
          "It's punishment for sin",
          "It proves God is weak"
        ],
        hint: "It's about God's sovereignty over even evil circumstances",
        funFact: "🚀 Church history: persecution often leads to explosive growth!"
      }
    },

    64: {
      name: "Philip in Samaria",
      challenge: "There was great joy in that city...",
      easy: {
        question: "Where did Philip go to preach?",
        options: [
          "To Rome",
          "To Samaria",
          "To Greece",
          "To Egypt"
        ],
        hint: "A region Jews typically avoided",
        funFact: "🌍 Gospel breaks down racial barriers - Samaritans receive good news!"
      },
      medium: {
        question: "What accompanied Philip's preaching?",
        options: [
          "Large crowds only",
          "Signs, miracles, and great joy",
          "Political support",
          "Financial prosperity"
        ],
        hint: "Supernatural confirmation of the Gospel",
        funFact: "✨ Miracles confirm the Gospel message - signs and wonders follow!"
      },
      hard: {
        question: "What does Philip's ministry teach about Gospel expansion?",
        options: [
          "Stay in safe places",
          "The Gospel breaks cultural and racial barriers",
          "Only apostles can do miracles",
          "Avoid different people groups"
        ],
        hint: "It's about Gospel universality crossing all boundaries",
        funFact: "🌈 From Jerusalem to Samaria - Gospel bridge across ancient hostility!"
      }
    },

    65: {
      name: "Philip and the Ethiopian",
      challenge: "Do you understand what you are reading?",
      easy: {
        question: "What was the Ethiopian official reading?",
        options: [
          "The Psalms",
          "The book of Isaiah",
          "Genesis",
          "The Torah"
        ],
        hint: "The prophet who wrote about the suffering servant",
        funFact: "📖 Isaiah 53 - the perfect passage about Jesus' sacrifice!"
      },
      medium: {
        question: "How did Philip join the Ethiopian?",
        options: [
          "By coincidence",
          "The Spirit told Philip to approach the chariot",
          "He was invited",
          "He was traveling the same way"
        ],
        hint: "Divine guidance for divine appointment",
        funFact: "🏃 Philip ran to obey the Spirit - urgency in evangelism!"
      },
      hard: {
        question: "What does this encounter teach about personal evangelism?",
        options: [
          "Only preach to large crowds",
          "Be sensitive to the Spirit's leading for individual opportunities",
          "Avoid people from other cultures",
          "Only trained ministers can evangelize"
        ],
        hint: "It's about Spirit-led personal ministry",
        funFact: "💧 Ethiopian baptized immediately - Gospel for all nations begins!"
      }
    }
  }
};

export default chapter5Translations;